import script from "./BlockTransactionFrequency.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTransactionFrequency.vue?vue&type=script&setup=true&lang=js"

import "./BlockTransactionFrequency.vue?vue&type=style&index=0&id=e03f6c32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e03f6c32"]])

export default __exports__